import axios from 'axios';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";
import {loadFaxDataInStore} from "../fax/actions";


export const LOAD_PROPERTYVEHICLE_DATA = 'propertyvehicle/LOAD_PROPERTYVEHICLE_DATA';
export const DELETE_A_PROPERTYVEHICLE = 'propertyvehicle/DELETE_A_PROPERTYVEHICLE';
export const SAVE_A_PROPERTYVEHICLE = 'propertyvehicle/SAVE_A_PROPERTYVEHICLE';
export const UPDATE_A_PROPERTYVEHICLE = 'propertyvehicle/UPDATE_A_PROPERTYVEHICLE';
export const CLEAR_A_PROPERTYVEHICLE_ERROR_MESSAGE = 'propertyvehicle/CLEAR_A_PROPERTYVEHICLE_ERROR_MESSAGE';


export function clearPropertyVehicleErrorMsgInStore() {
	return {
		type: CLEAR_A_PROPERTYVEHICLE_ERROR_MESSAGE,
		
	}
}

export function loadPropertyvehicleDataInStore(argPropertyvehicleDataArray) {
	return {
		type: LOAD_PROPERTYVEHICLE_DATA,
		propertyvehiclesData: argPropertyvehicleDataArray
	}
}

export function deleteAPropertyvehicleInStore(argDeleteResponse, argErrorMsg) {
	return {
		type: DELETE_A_PROPERTYVEHICLE,
		deletePropertyvehicleResponse: argDeleteResponse,
		errorMsg: argErrorMsg
	}
}

export function saveAPropertyvehicleDataInStore(argSaveResponse, argErrorMsg) {
	return {
		type: SAVE_A_PROPERTYVEHICLE,
		savePropertyvehicleResponse: argSaveResponse,
		errorMsg: argErrorMsg
	}
}

export function updateAPropertyvehicleDataInStore(argSaveResponse, argErrorMsg) {
	return {
		type: UPDATE_A_PROPERTYVEHICLE,
		updatePropertyvehicleResponse: argSaveResponse,
		errorMsg: argErrorMsg
	}
}

/********************* End of InStore calls **************************/

//****************************************
//Add Fax to the Faxs Array
//****************************************
export function addPropertyVehicleToPropertyVehiclesArray(argVehicle ) {
	return (dispatch, getState) => {
		const state = getState();
		console.log("addPropertyVehicleToPropertyVehiclesArray is called");
		console.log("addPropertyVehicleToPropertyVehiclesArray vehicle is " + argVehicle.vehicleid );
		//First I want to remove any if already exist in the array and then add the new one.
		let tempCarArray=[] ;
		tempCarArray = Object.assign(tempCarArray,state.propertyvehicle.propertyvehiclesArray);
		
		let newVehicleId = argVehicle.vin+argVehicle.platenumber+argVehicle.state;
		//newVehicleId = newVehicleId.replace("[^a-zA-Z0-9]", "");
		newVehicleId = newVehicleId.replace(/\W/g, '');
		newVehicleId = newVehicleId.toLowerCase();
		console.log("Farshid the new vehicle id is "+ newVehicleId);
		
		//removig the match element with the matching id.
		let newCarArray = tempCarArray.filter(element => { return element.vehicleid !== newVehicleId});
		console.log(newCarArray);
		//let tempFaxsArray=[] ;
		//tempFaxsArray = Object.assign(tempFaxsArray,state.propertyvehicle.propertyvehiclesArray);
		//adding to the top of the array.
		newCarArray.unshift(argVehicle);
		//tempTowJobsArray.concat(argTowJob);
		dispatch(loadPropertyvehicleDataInStore(newCarArray));
	}//end of return
}

//****************************************
//Delete Fax from the Faxs Array
//****************************************
export function deletePropertyVehicleFromPropertyVehiclesArray(argFaxId ) {
	return (dispatch, getState) => {
		const state = getState();
		let tempFaxsArray=[] ;
		tempFaxsArray = Object.assign(tempFaxsArray,state.propertyvehicle.propertyvehiclesArray);
		//removig the match element with the matching id.
		let newArray = tempFaxsArray.filter(element => { return element.id != argFaxId });
		//tempTowJobsArray.concat(argTowJob);
		dispatch(loadPropertyvehicleDataInStore(newArray));
	}//end of return
}
//****************************************
//update Fax in the Faxs Array
//****************************************
export function updatePropertyVehicleInPropertyVehiclesArray(argFAx ) {
	return (dispatch, getState) => {
		const state = getState();
		let tempFaxsArray=[] ;
		tempFaxsArray = Object.assign(tempFaxsArray,state.propertyvehicle.propertyvehiclesArray);
		//rempoving the item from the array and then add the updated one to the array array.
		let newArray = tempFaxsArray.filter(element => { return element.id != argFAx.id });
		//adding to the top of the array.
		newArray.unshift(argFAx);
		//tempTowJobsArray.concat(argTowJob);
		dispatch(loadPropertyvehicleDataInStore(newArray));
	}//end of return
}





//****************************************
//Below is for update a Stream
//****************************************
export function clearPropertyVehicleErrorMsg() {
	return (dispatch, getState) => {
		dispatch(clearPropertyVehicleErrorMsgInStore());
	}
}

export function updateAPropertyvehicle(argURL, argPropertyvehicle, argCompanyId) {
	return (dispatch, getState) => {
		const state = getState();
		updateAPropertyvehicleOnServer(argURL, argPropertyvehicle, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (saveResponse) {
			
			dispatch(updateAPropertyvehicleDataInStore(saveResponse.data, {
				"status": saveResponse.status,
				"statusText": saveResponse.statusText
			}));
			
		}, function (err) {
			var errorObj = AppUtils.getErroStatusAndText(err);
			console.log("I had an error updating a company-property" + errorObj.statusText + errorObj.status);
			dispatch(updateAPropertyvehicleDataInStore({}, errorObj));
		});
	}//end of return
}


function updateAPropertyvehicleOnServer(argURL, argPropertyvehicle, argCompanyId, argIdToken, argUserId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfPutsForUpdateAPropertyvehicle(argURL, argPropertyvehicle, argCompanyId, argIdToken, argUserId)).then(function (responses) {
				resolve(responses[0]);
			}, function (err) {
				//console.log("Farshid some error occured on saving a StorageLot " + err.message +  " the URL is " + argURL );
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getArrayOfPutsForUpdateAPropertyvehicle(argURL, argPropertyvehicle, argCompanyId, argIdToken, argUserId) {
	/*
	 I build something like this :
	 http://localhost:4567/companys
	 */
	
	let baseUrl = argURL + "users/" + argUserId + "/companies/" + argCompanyId + "/propertyvehicle";
	console.log(" on posting a propertyvehicle the URL is " + baseUrl);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.put(baseUrl, argPropertyvehicle, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAPropertyvehicle(argURL, argPropertyVehicle, argCompanyId) {
	return (dispatch, getState) => {
		const state = getState();
		saveAPropertyvehicleOnServer(argURL, argPropertyVehicle, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (saveResponse) {
			
			dispatch(saveAPropertyvehicleDataInStore(saveResponse.data, {
				"status": saveResponse.status,
				"statusText": saveResponse.statusText
			}));
			
		}, function (err) {
			var errorObj = AppUtils.getErroStatusAndText(err);
			console.log("I had an error saving a Company Property" + errorObj.statusText + errorObj.status);
			dispatch(saveAPropertyvehicleDataInStore({}, errorObj));
		});
	}//end of return
}


function saveAPropertyvehicleOnServer(argURL, argPropertyVehicle, argCompanyId, argIdToken, argUserId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfPostsForSaveAPropertyvehicle(argURL, argPropertyVehicle, argCompanyId, argIdToken, argUserId)).then(function (responses) {
				resolve(responses[0]);
			}, function (err) {
				//console.log("Farshid some error occured on saving a propertyvehicle " + err.message +  " the URL is " + argURL );
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getArrayOfPostsForSaveAPropertyvehicle(argURL, argPropertyVehicle, argCompanyId, argIdToken, argUserId) {
	/*
	 I build something like this :
	 http://localhost:4567/companys
	 */
	
	let baseUrl = argURL + "users/" + argUserId + "/companies/" + argCompanyId + "/propertyvehicle";
	console.log(" on posting a propertyvehicle the URL is " + baseUrl);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.post(baseUrl, argPropertyVehicle, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteAPropertyvehicle(argURL, argPropertyVehicleId, argCompanyId) {
	return (dispatch, getState) => {
		const state = getState();
		deleteAPropertyvehicleOnServer(argURL, argPropertyVehicleId, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (deleteResponse) {
			
			dispatch(deleteAPropertyvehicleInStore(deleteResponse.data, {
				"status": deleteResponse.status,
				"statusText": deleteResponse.statusText
			}));
			
		}, function (err) {
			var errorObj = AppUtils.getErroStatusAndText(err);
			console.log("I had an error deleting a company property " + errorObj.statusText + errorObj.status);
			dispatch(deleteAPropertyvehicleInStore({}, errorObj));
		});
	}//end of return
}


function deleteAPropertyvehicleOnServer(argURL, argPropertyVehicleId, argCompanyId, argIdToken, argUserId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfDeletesForDeleteAPropertyvehicle(argURL, argPropertyVehicleId, argCompanyId, argIdToken, argUserId)).then(function (responses) {
				resolve(responses[0]);
			}, function (err) {
				//console.log("Farshid some error occured on deleteing a Propertyvehicle " + err.message +  " the URL is " + argURL );
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getArrayOfDeletesForDeleteAPropertyvehicle(argURL, argPropertyVehicleId, argCompanyId, argIdToken, argUserId) {
	/*
	 I build something like this :
	 http://localhost:4567/cameras
	 */
	
	let baseUrl = argURL + "users/" + argUserId + "/companies" + "/" + argCompanyId + "/propertyvehicle/" + argPropertyVehicleId;
	console.log(" on deleteing a Propertyvehicle the URL is " + baseUrl);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}


//Get list of companys

export function loadPropertyvehiclesData(argURL, argCompanyId, argPropertyId) {
	return (dispatch, getState) => {
		const state = getState();
		getListOfPropertyvehicles(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id, argPropertyId).then(function (companysList) {
			
			dispatch(loadPropertyvehicleDataInStore(companysList));
			
		}, function (err) {
			console.log("I had an error gettting Farms Data2" + err);
		});
	}//end of return
}

function getArrayOfGetsForListOfPropertyvehicles(argURL, argCompanyId, argIdToken, argUserId, argPropertyId) {
	/*
	 I build something like this :
	 http://localhost:4567/company
	 */
	
	let baseUrl = argURL + "users/" + argUserId + "/companies/" + argCompanyId + "/property/"+argPropertyId+"/propertyvehicle";
	console.log(" on getting list of Propertyvehicles  the URL is " + baseUrl);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.get(baseUrl, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}

function getListOfPropertyvehicles(argURL, argCompanyId, argIdToken, argUserId, argPropertyId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		var arrayOfGets = [];
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfGetsForListOfPropertyvehicles(argURL, argCompanyId, argIdToken, argUserId, argPropertyId)).then(function (responses) {
				resolve(responses[0].data);
			}, function (err) {
				console.log("Farshid some error occured on getting list of Companys " + err.message + " the URL is " + argURL);
				reject(err);
			});
		}
	});
	
	return returnPromise;
}

